import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["Slot"], {
        id: $setup.formItemId,
        "data-slot": "form-control",
        "aria-describedby": !$setup.error ? `${$setup.formDescriptionId}` : `${$setup.formDescriptionId} ${$setup.formMessageId}`,
        "aria-invalid": !!$setup.error
    }, {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["id", "aria-describedby", "aria-invalid"]));
}
